<template>
  <div class="room-user-change-nickname-component" @keyup="keymap">
    <div class="room-user-change-nickname flex flex-col gap-y-3">
      <div class="change-nickname-body flex flex-col gap-y-3">
        <div class="change-nickname-text-container">
          <div class="change-nickname-text title">{{ $t("chat.changeNickname") }}</div>
        </div>
        <GrmTextField
          focus
          ref="nickname"
          :value="nickname"
          :maxlength="25"
          @input="onInputNickname"
        />
      </div>
      <div class="change-nickname-footer">
        <ul class="button-list">
          <li class="button-item"><VButton class="cancel" @click="onClickCancel">{{ $t("common.cancel") }}</VButton></li>
          <li class="button-item"><VButton ref="ok" @click="onClickOk">{{ $t("common.confirm") }}</VButton></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import VButton from "@/components/Common/VButton";
import {mapActions, mapGetters} from "vuex";
import RoomJoinGuest from "@/components/Room/Join/RoomJoinGuest.vue";
import GrmTextField from "@/components/Common/textField/GrmTextField.vue";

export default {
  name: 'RoomUserChangeNickname',
  components: {
    GrmTextField,
    VButton
  },
  data() {
    return {
      nickname: '',
    }
  },
  created() {
    this.nickname = this.$parent.user.nickname;
  },
  methods: {
    ...mapActions('user', [
      'changeRoomUserNickname'
    ]),
    keymap(e) {
      switch (e.keyCode) {
        case 27: // esc
          this.onClickCancel()
          break
      }
    },
    onClickCancel() {
      this.close()
    },
    onClickOk() {
      const THIS = this;
      const { nickname } = this;

      if (!nickname || nickname.trim() === '') {
        this.$alert({
          text: this.$t('user.changeNickname'),
          onlyOk: true,
          ok() {
            THIS.$refs.nickname.$refs.input.focus();
          }
        });
        return;
      } else if (this.$parent.user.nickname !== nickname) {
        this.changeRoomUserNickname({ roomUser: this.$parent.user, nickname });
      }
      this.close()
    },
    close() {
      this.$modal('RoomUserChangeNickname');
    },
    onInputNickname(value) {
      this.nickname = value.trim();
    },
  },
}
</script>

<style lang="scss" scoped>
.room-user-change-nickname-component {
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  &.fadeIn {
    animation: fadeIn 0.2s ease-out forwards;
  }
  &.fadeOut {
    animation: fadeOut 0.2s ease-out forwards;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
      visibility: hidden;
    }
    100% {
      opacity: 1;
      visibility: visible;
    }
  }
  @keyframes fadeOut {
    0% {
      opacity: 1;
      visibility: visible;
    }
    100% {
      opacity: 0;
      visibility: hidden;
    }
  }
}
.room-user-change-nickname {
  min-width: 320px;
  border-radius: 10px;
  padding: 36px 30px 30px;
  background-color: #fff;
  box-sizing: border-box;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
  text-align: center;
}
.change-nickname-text-container {
  display: flex;
  flex-direction: column;
  gap: 20px 0;
}
.change-nickname-text {
  &.title {
    font-size: 24px;
    font-weight: 700;
  }
}
.room-user-change-nickname-footer {
  margin-top: 30px;
}
.button-list {
  display: flex;
  justify-content: center;
  gap: 0 10px;
}
.button {
  min-width: 100px;
  border-radius: 6px;
  padding: 0 24px;
  font-size: 15px;
  line-height: 40px;
  transition: 0.1s ease-out;
  &.cancel {
    background-color: #f1f2f3;
    color: #666;
    &:hover {
      background-color: #ddd;
    }
  }
  &.ok {
    background-color: $mainColor;
    color: #fff;
    &:hover {
      background-color: $subColor;
    }
  }
}
</style>